import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { FeatureTypeRequest, FeatureTypeRequestMultiple, SearchRequest } from "@app/_api/njdbpawebb/models";

@Injectable({
    providedIn: "root",
})
export abstract class NetDbService {
    abstract infoClickInCoordinate(featureTypeRequest: FeatureTypeRequest): Observable<string>;

    abstract infoClickMultiple(featureTypeRequestMultiple: FeatureTypeRequestMultiple): Observable<string>;

    abstract searchAll(searchObj: SearchRequest): Observable<string>;

    abstract getDescription(metaKey: string): Observable<string>;

    abstract getLastFeatureUpdateNVDB(): Observable<string>


}

@Injectable({
    providedIn: "root",
})
export class EmptyNetDbService implements NetDbService {
    public getLastFeatureUpdateNVDB(): Observable<string> {
        throw new Error("Method not implemented.");
    }

    public infoClickInCoordinate(featureTypeRequest: FeatureTypeRequest): Observable<string> {
        throw new Error("Method not implemented.");
    }

    public infoClickMultiple(featureTypeRequestMultiple: FeatureTypeRequestMultiple): Observable<string> {
        throw new Error("Method not implemented.");
    }

    public searchAll(searchObj: SearchRequest): Observable<string> {
        throw new Error("Method not implemented.");
    }

    public getDescription(metaKey: string): Observable<string> {
        throw new Error("Method not implemented.");
    }

}
